<template>
  <div class="index" v-if="showPage">
    <div class="header" id="header">
      <span class="choose-school" @click="chooseSchool" v-if="!schoolLock">
        <span class="ellipse">{{ schoolInfo.schoolName }}</span>
      </span>
      <span class="choose-school no-choose" v-else>
        <span class="ellipse">{{ schoolInfo.schoolName }}</span>
      </span>
      <span class="to-search" @click="toSearch">搜索</span>
    </div>
    <div class="main">
      <!--轮播banner-->
      <div class="banner card" id="banner" v-if="banners.length>0">
        <div v-if="banners.length>1" style="width:100%;height: 100%">
          <div class="swiper-container banner-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in banners" style="padding: 0 .2rem;position: relative">
                <img :src="item.imageUrl" style="width: 100%;height: 100%;border-radius: .16rem"/>
                <wx-open-launch-weapp
                  v-if="item.type == 500085"
                  style="position: absolute;width: 100%;height: 100%;top:0;left:0"
                  :username="JSON.parse(item.data).miniProgramId"
                  :path="JSON.parse(item.data).path">
                  <script type="text/wxtag-template">
                    <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>
                    <button class="btn"></button>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </div>
          </div>
          <div class="pagination"></div>
        </div>
        <div style="width:100%;height: 100%;position: relative" v-else>
          <img :src="banners[0].imageUrl" @click="bannerJump(banners[0],'118','click_home_top_banner')"
                style="width:100%;height: 100%;border-radius: .16rem">
          <wx-open-launch-weapp
            v-if="banners[0].type == 500085"
            style="position: absolute;width: 100%;height: 100%;top:0;left:0"
            :username="JSON.parse(banners[0].data).miniProgramId"
            :path="JSON.parse(banners[0].data).path">
            <script type="text/wxtag-template">
              <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>
              <button class="btn"></button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
      <!--A页面-->
      <div v-if="isOpenA">
        <div v-if="tagList.length>0 || shopList.length>0">
          <div class="category-list" v-if="tagList.length>0">
            <ul class="card shop-list">
              <li v-for="item in tagList" style="position: relative">
                <a @click="toGoHomePage(item,1)">
                  <span class="icon" :style="{backgroundImage:'url('+item.show_icon+')'}"></span>
                  <span class="ellipse"
                        style="display: block;font-size: .22rem;color: #666;height: .28rem;">{{ item.show_name }}</span>
                </a>
                <wx-open-launch-weapp
                  v-if="item.app_jump_type == 500085"
                  style="position: absolute;width: 100%;height: 100%;top:0;left:0"
                  :username="JSON.parse(item.app_jump_params).miniProgramId"
                  :path="JSON.parse(item.app_jump_params).path">
                  <script type="text/wxtag-template">
                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>
                    <button class="btn"></button>
                  </script>
                </wx-open-launch-weapp>
              </li>
            </ul>
          </div>
          <!--公告走马灯-->
          <div class="marquee" v-if="noticeContent && noticeContent != '' " @click="getNoticeDetail">
            <div class="marquee_bg card tag-list">
              <span class="notice_icon"></span>
              <!--<div class="notice_split_line"></div>-->
              <!--<div style="width:80%;height: 100%"><marquee scrollamount=3>{{noticeContent}}</marquee></div>-->
              <div class="marquee-box">
                <div>
                  <p id="marquee-dom">{{ noticeContent }}</p>
                </div>
              </div>
              <!--<span class="notice_icon_arrow"></span>-->
            </div>
          </div>
          <!--推荐下单活动入口-->
          <!-- <div class="recommend" @click="toRecommend(activity)" v-if="showRecommend"
               :style="{backgroundImage: 'url('+ activity.imageUrl +')'}"></div> -->
          <!--幻灯片-->
          <div class="lantern-slide lantern-list">
            <div class="card" @click="lanternSlideJump(item2)" v-for="item2 in lanternSlideList">
              <img :src="item2.show_icon" width="100%"/>
            </div>
          </div>
          <!--<div v-if="lanternSlideList.length == 0 && activity==''" class="split_line" style="height: 0.26rem;background-color: #f6f6f6"></div>-->
          <!--<div v-if="activity==''" class="split_line" style="height: 0.1rem;background-color: #f8f8f8"></div>-->
          <div class="goods-list card" v-if="shopList.length>0">
            <div class="goods-title">本校食堂</div>
            <ul>
              <li v-for="item in shopList" style="padding: 0.2rem 0 0 0;position: relative">
                <div class="goods-box" @click="toGoHomePage(item)">
                  <a>
                    <div class="lazy shopimg fl" :style="{backgroundImage:'url('+item.show_icon+')'}"></div>
                    <div class="shopname fl">{{ item.show_name }}</div>
                    <wx-open-launch-weapp
                      v-if="item.app_jump_type == 500085"
                      style="position: absolute;width: 100%;height: 100%;top:0;left:0"
                      :username="JSON.parse(item.app_jump_params).miniProgramId"
                      :path="JSON.parse(item.app_jump_params).path">
                      <script type="text/wxtag-template">
                        <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>
                        <button class="btn"></button>
                      </script>
                    </wx-open-launch-weapp>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--非A页面-->
      <div v-if="!isOpenA">
        <div class="category-list" ref="categoryList" v-if="shopCategoryList.length>0">
          <ul class="card shop-list">
            <li v-for="(item,index) in shopCategoryList" :key="index" style="position: relative">
              <a @click="toShopList(item)">
                <span class="icon" :style="item.backgroundimg"></span>
                <span class="ellipse c-666 fs-22"
                      style="display: block;height: .28rem;">{{ item.show_name }}</span>
                <wx-open-launch-weapp
                  v-if="item.app_jump_type == 500085"
                  style="position: absolute;width: 100%;height: 100%;top:0;left:0"
                  :username="JSON.parse(item.app_jump_params).miniProgramId"
                  :path="JSON.parse(item.app_jump_params).path">
                  <script type="text/wxtag-template">
                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>
                    <button class="btn"></button>
                  </script>
                </wx-open-launch-weapp>
              </a>
            </li>
          </ul>
        </div>
        <!--公告走马灯-->
        <div class="marquee" v-if="noticeContent && noticeContent != '' " @click="getNoticeDetail">
          <div class="marquee_bg card tag-list">
            <span class="notice_icon"></span>
            <!--<div class="notice_split_line"></div>-->
            <!--<div style="width:80%;height: 100%"><marquee scrollamount=3>{{noticeContent}}</marquee></div>-->
            <div class="marquee-box">
              <div>
                <p id="marquee-dom">{{ noticeContent }}</p>
              </div>
            </div>
            <!--<span class="notice_icon_arrow"></span>-->
          </div>
        </div>
        <!--推荐下单活动入口-->
        <!-- <div class="recommend" @click="toRecommend(activity)" v-if="showRecommend"
             :style="{backgroundImage: 'url('+ activity.imageUrl +')'}"></div> -->
        <!--幻灯片-->
        <div class="lantern-slide lantern-list">
          <div class="card" @click="lanternSlideJump(item2)" v-for="item2 in lanternSlideList">
            <img :src="item2.show_icon" width="100%"/>
          </div>
        </div>
        <!--权益商家-->
        <div class="benefit card" id="benefit" v-if="benefitList.length>0">
          <div v-if="benefitList.length>1">
            <div class="swiper-container benefit-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in benefitList" style="padding: .20rem;position: relative">
                  <div style="display: flex">
                    <div class="item-img" @click="benefitJump(item)">
                      <img :src="item.pic" style="width:2.0rem;height: 3.5rem;" />
                    </div>
                    <div class="item-desc">
                      <div>
                        <div class="name ellipses" style="font-size: .32rem;font-weight: 600;"  @click="benefitJump(item)">{{item.shop_name}}</div>
                        <div class="item-tag">
                          <span v-if="item.is_open == 1">
                            <span v-if="item.is_book == 1" class="shop-status can-reserve">可预订</span>
                            <span v-else class="shop-status">营业中</span>
                          </span>
                          <span class="shop-status close" v-else>已打烊</span>
                        </div>
                      </div>
                      <div class="flex-row-bc" style="margin-top: 0.03rem">
                        <div class="fs-22 flex-row-cc" >
                          <img class="star" src="../assets/images/icon-star.png" style="width: .24rem;height: .24rem">
                          <span style="margin-right:.10rem;font-size: .26rem;color: #FFB300;">{{item.score}}</span>
                          <span class="argver">月售{{item.sales_append}}单</span>
                        </div>
                        <!-- <span class="argver" v-if="item.cpi">人均¥{{item.cpi}}</span> -->
                        <span class="argver" v-if="item.dinnerDuration">{{item.dinnerDuration}}</span>
                      </div>
                      <div class="scroller" style="margin-top: 0.05rem">
                        <span class="item-imgs" v-if="item.promotion_list && item.promotion_list.length > 0">
                          <img v-if="item.promotion_list" v-for="pro in item.promotion_list"  :src="pro.icon_url" mode="widthFix" style="width: .30rem;margin-right: .10rem" />
                        </span>
                        <span class="item-package"  v-if="item.promotion_package && item.promotion_package.length > 0">
                          <div  v-for="package in item.promotion_package">{{package.package_desc}}</div>
                        </span>
                        <span class="item-promotion"  v-if="item.promotion_reduce && item.promotion_reduce.reduce_info && item.promotion_reduce.reduce_info.length > 0">
                          <div class="reduce" v-for="promotion in item.promotion_reduce.reduce_info">{{promotion.meet_price}}减{{promotion.cut_price}}</div>
                        </span>
                        <span class="item-coupon" v-if="item.coupon_list && item.coupon_list.length > 0">
                          <div class="desc" v-for="coupon in item.coupon_list">
                            {{coupon.couponDes}}
                          </div>
                        <span class="get">领券</span>

                      </span>
                      </div>
                      <div class="flex-row-bs" style="margin-top: 0.1rem">
                        <div v-for="good in item.goods">
                          <div class="flex-colum-ss" >
                            <img :src="good.thumbnail" @click="goodsJump(item,good)"  style="width: 1.38rem;height:1.38rem;" />
                            <div class="ellipses" style="font-size: .24rem;width: 1.38rem;margin-top: .12rem;color: #333;">{{good.gdName}}</div>
                            <div class="fs-20" style="color: #FD394F;margin-top: .04rem;">￥<span class="fs-28" style="color: #FD394F;">{{good.salePrice}}</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <div style="width:100%;height: 100%;position: relative;display: flex" v-else>
            <div class="item-img" @click="benefitJump(benefitList[0])">
              <img :src="benefitList[0].pic" style="width:2.0rem;height: 3.5rem;" />
            </div>
            <div class="item-desc">
              <div>
                <div class="name ellipses" style="font-size: .32rem"  @click="benefitJump(benefitList[0])">{{benefitList[0].shop_name}}</div>
                <div class="item-tag">
                  <span v-if="benefitList[0].is_open == 1">
                    <span v-if="benefitList[0].is_book == 1" class="shop-status can-reserve">可预订</span>
                    <span v-else class="shop-status">营业中</span>
                  </span>
                  <span class="shop-status close" v-else>已打烊</span>
                </div>
              </div>
              <div class="flex-row-bc" style="margin-top: .12rem">
                <div class="fs-22 flex-row-cc" >
                  <img class="star" src="../assets/images/icon-star.png" style="width: .24rem;height: .24rem">
                  <span style="margin-right:.10rem;font-size: .26rem;color: #FFB300;">{{benefitList[0].score}}</span>
                  <span class="argver">月售{{benefitList[0].sales_append}}单</span>
                </div>
                <!-- <span class="argver">人均¥{{benefitList[0].cpi}}</span> -->
                <span class="argver" v-if="benefitList[0].dinnerDuration">{{benefitList[0].dinnerDuration}}</span>
              </div>
              <div class="scroller" style="margin-top: .14rem" v-if="benefitList && benefitList.length > 0">
                <span class="item-imgs" v-if="benefitList[0].promotion_list && benefitList[0].promotion_list.length > 0">
                  <img v-if="benefitList[0].promotion_list" v-for="pro in benefitList[0].promotion_list"  :src="pro.icon_url" mode="widthFix" style="width: .30rem;margin-right: .10rem" />
                  <span v-if="benefitList[0].showMsg">{{benefitList[0].promotion_list[0].promotion_name}}</span>
                </span>
                <span class="item-package"  v-if="benefitList[0].promotion_package && benefitList[0].promotion_package.length > 0">
                  <span  v-for="package in benefitList[0].promotion_package">{{package.package_desc}}</span>
                </span>
                <span class="item-promotion"  v-if="benefitList[0].promotion_reduce && benefitList[0].promotion_reduce.reduce_info && benefitList[0].promotion_reduce.reduce_info.length > 0">
                  <span class="reduce" v-for="promotion in benefitList[0].promotion_reduce.reduce_info">{{promotion.meet_price}}减{{promotion.cut_price}}</span>
                </span>
                <span class="item-coupon" v-if="benefitList[0].coupon_list && benefitList[0].coupon_list.length > 0">
                    <div class="desc" v-for="coupon in benefitList[0].coupon_list">
                      {{coupon.couponDes}}
                    </div>
                    <span class="get">领券</span>
                  </span>
              </div>
              <div class="flex-row-bs" style="margin-top: .08rem">
                <div v-for="good in benefitList[0].goods" >
                  <div class="flex-colum-ss">
                    <img :src="good.thumbnail" @click="goodsJump(benefitList[0],good)"  style="width: 1.38rem;height:1.38rem;" />
                    <div class="ellipses" style="font-size: .24rem;width: 1.38rem;margin-top: .12rem;color: #333;">{{good.gdName}}</div>
                    <div class="fs-20" style="color: #FD394F;margin-top: .04rem;">￥<span class="fs-28" style="color: #FD394F;">{{good.salePrice}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div v-if="activity==''" class="split_line" style="height: 0.1rem;background-color: #f8f8f8"></div>-->
        <div v-if="isOpenOrder">
          <div :class="isFixed ? 'fixed':''"  id="goods-title1"  class="goods-title1 flex-colum-ss" :style="{top: headerHeight + 'px'}">
            <div class="shop-title">
              <div v-for="item in shopTitles" class="item" :class="item.checked? 'active' : ''"  @click="switchTitle(item)">
                {{item.title}}
                <span></span>
              </div>
            </div>
            <div class="shop-title1 flex-row-bc-w" v-if="!currentTitle">
              <div v-for="item in shopSorts" class="item1" :class="item.checked? 'active' : ''"
                   :style="{backgroundColor: isFixed ? '#f8f8f8': '' }" @click="switchSort(item)">
                {{item.title}}
              </div>
            </div>
          </div>
          <div class="goods-list shop card" style="min-height: 15rem"  id="goods-list">
            <ul class="goods-ul" style="min-height: 100vh" v-if="currentShopList.length">
              <li v-for="(item,index4) in currentShopList"  :key="index4" style="padding: 0.2rem 0;">
                <div class="goods-box">
                  <a>
                    <div class="goods-img" @click="toGoodsList(item.id,item.shop_name)">
                      <div class="lazy goodimg" :style="item.backgroundimg"></div>
                      <div class="mark" v-if="item.is_mark == 1" :style="{backgroundColor:item.mark_color}">
                        {{ item.mark }}
                      </div>
                    </div>
                    <div class="goods-des" @click="toGoodsList(item.id,item.shop_name)">
                      <div class="name ellipse">{{ item.shop_name }}</div>
                      <div class="comment" style="margin-top:0.03rem">
                        <!--<CommentStars :qualityCode="item.score"></CommentStars>-->
                        <img class="star" src="../assets/images/icon-star.png">
                        <span style="color: #FEC300">{{ item.score }}</span>
                        <span style="color: #E3E3E3">|</span>
                        <span>月售 {{ item.sales_append }}单</span>
                      </div>
                      <div class="flex-row-bc">
                        <div class="flex-row-sc">
                          <span style="margin-right: 0.05rem">起送￥{{ item.threshold_amount }}</span>
                          <span style="color: #E3E3E3;margin-right: 0.05rem">|</span>
                          <span v-if="item.delivery_fee_text">{{item.delivery_fee_text}}</span>
                          <template v-else>
                            <span>配送￥</span>
                            <span v-if="item.new_delivery_fee || item.new_delivery_fee === 0">{{item.new_delivery_fee}}</span>
                            <span v-else>{{ item.delivery_fee }}</span>
                            <span v-if="item.is_many_delivery == 1">起</span>
                          </template>
                          <template v-if="item.new_delivery_fee || item.new_delivery_fee === 0">
                            <span style="color: #999;text-decoration: line-through;margin-right:0">￥{{item.delivery_fee}}</span>
                          </template>
<!--                          <div v-if="item.new_delivery_fee || item.new_delivery_fee === 0">-->
<!--                            <span style="margin-right: 0">配送￥{{item.new_delivery_fee}}</span>-->
<!--                            <span v-if="item.is_many_delivery == 1">起</span>-->
<!--                            <span v-if="item.delivery_fee" style="color: #999;text-decoration: line-through;margin-right:0">￥{{item.delivery_fee}}</span>-->
<!--                          </div>-->
<!--                          <div v-else>-->
<!--                            <span style="margin-right: 0">配送￥{{item.delivery_fee}}</span>-->
<!--                            <span v-if="item.is_many_delivery == 1">起</span>-->
<!--                          </div>-->
                          <span v-if="item.delivery_type == 1">(商家配送)</span>
                        </div>
                        <div v-if="item.dinnerDuration">{{item.dinnerDuration}}</div>
                      </div>
                    </div>
                    <!--店铺副标题、准时达-->
                    <div class="flex-row-bc">
                      <div class="vice_title" v-if="item.vice_title">{{ item.vice_title }}</div>
                      <div class="punctual-arrive" v-if="item.zsd">{{ item.zsd }}</div>
                    </div>
                    <!--促销活动-->
                    <div class="promotion_reduce" style="padding-left: 0.2rem" v-if="item.promotion_reduce && item.promotion_reduce.reduce_info">
                      <span v-for="(item2,index3) in item.promotion_reduce.reduce_info" :key="index3"
                            class="promotion_reduce-type border">{{ item2.meet_price }}减{{ item2.cut_price }}</span>
                    </div>
                    <!--店铺优惠券-->
                    <div class="promotion-and-coupon" style="margin: .1rem 0 0 2.2rem;">
                      <div class="promotion" v-if="item.promotion_list && item.promotion_list.length > 0">
                        <img class="icon" v-for="pro in item.promotion_list" :src="pro.icon_url" width="100%" >
                      </div>
                      <div class="package" v-if="item.promotion_package && item.promotion_package.length > 0">
                        <span v-for="(proPackage,index5) in item.promotion_package" :key="index5">{{proPackage.package_desc}}</span>
                        <span v-if="item.showMsg">{{item.promotion_list[0].promotion_name}}</span>
                      </div>
                      <div class="coupon" v-if="item.coupon_list && item.coupon_list.length > 0">
                        <span class="desc" v-for="(coupon,index6) in item.coupon_list" :key="index6">{{ coupon.couponDes }}</span>
                        <span class="get">领券</span>
                      </div>
                    </div>
                    <!-- <div class="des" @click="showMoreGift(item)"
                         :class="[{'arrow-down':item.promotion_list.length>2 && item.iShowMore!=true}, {'arrow-up': item.promotion_list.length>2 && item.iShowMore==true}]"
                         v-if="item.promotion_list.length>0" style="position: relative">
                      <div v-if="item.iShowMore">
                        <p v-for="pro in item.promotion_list">
                          <span :style="{backgroundImage: 'url('+pro.icon_url+')'}">{{ pro.promotion_name }}</span>
                        </p>
                      </div>
                      <div v-else>
                        <p v-for="pro in item.promotion_list.slice(0,2)">
                          <span :style="{backgroundImage: 'url('+pro.icon_url+')'}">{{ pro.promotion_name }}</span>
                        </p>
                      </div>
                    </div> -->
                    <span v-if="item.is_open == 1">
                      <span v-if="item.is_book == 1" class="shop-status can-reserve">可预订</span>
                      <span v-else class="shop-status">营业中</span>
                    </span>
                    <span class="shop-status close" v-else>已打烊</span>
                    <div class="shop-type-box">
                      <span class="shop-type border" v-if="item.is_self_take_new == 1">自提</span>
                      <span class="shop-type border" v-if="item.is_take_out == 1">外送</span>
                      <span class="shop-type eat-in border" v-if="item.is_eat_in == 1">堂食</span>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="currentShopList.length == 0 && noData" class="my-content">
            <img src="../assets/images/wait.png" style="width: 2.00rem;height:2.74rem;margin: auto;">
            <span>暂时没有符合条件的店铺去其他分类看看吧~</span>
          </div>
        </div>
      </div>
      <div v-if="!isOpenOrder" class="clearflow" style="height: 100vh;background: #fff;">
        <div class="empty-school">
          <img src="../assets/images/empty-00.png"/>
          <h3 style="font-weight: normal;margin: 0" v-if="!isjdlw">业务筹备中</h3>
          <p style="font-size: .24rem;" v-if="isjdlw">亲爱的同学，你的学校当前尚未开通，我们全力开拓中，敬请期待~</p>
          <p style="font-size: 0.26rem;color:#787878;" v-if="!isYSF">请下载APP体验更多服务</p>
          <div class="btn btn-main" style="margin: 0;padding:0.22rem 0.72rem;border-radius: 10rem" v-if="!isYSF">
            <a href="https://dl.anlaiye.com" style="color: #000;font-size: 0.32rem">下载APP</a>
          </div>
        </div>
      </div>

      <div class="bottomTips" style="bottom: 1.3rem;" v-if="showBottomTips">
        <p>上海鎏帑网络科技有限公司 沪ICP备18024716号-1</p>
        <div>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817"
             style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../assets/images/record-icon.png"
                 style="width:0.2rem;height:0.2rem;margin-top:0.08rem;float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备
              31010402004817号</p>
          </a>
        </div>
        <p> 联系电话：021-60761299</p>
      </div>
    </div>
    <!--推荐领红包弹框-->
    <div class="notice_detail_alert coupon" @click="showCouponAlert = false" v-if="showCouponAlert">
      <div class="notice_detail_content">
        <div class="top">
          <img src="../assets/images/order-coupon-title1.png" width="100%" alt="">
        </div>
        <div class="body">
          <div class="title" v-if="couponInfo.partner==3">{{ couponInfo.target_title }}</div>
          <div class="title" v-if="couponInfo.partner==2">{{ couponInfo.new_title }}</div>
          <div class="title" v-if="couponInfo.partner==1">{{ couponInfo.old_title }}</div>
          <div class="title" v-if="couponInfo.partner==0">{{ couponInfo.all_title }}</div>
          <div class="list">
            <div class="item" v-for="(item,index) in couponInfo.list" :key="index">
              <div class="flex-row-bc">
                <div class="flex-row-sc">
                  <img v-if="item.coupon_type == 2" src="../assets/images/icon-coupon-discount.png" alt="">
                  <img v-else src="../assets/images/icon-coupon-reduce.png" alt="">
                  <div style="width: 2.45rem">
                    <div class="fs-30 fw-bold ellipse">{{item.coupon_name}}</div>
                    <div class="fs-22" style="color: #999;margin-top: .16rem">有效期至：{{ item.coupon_end_time }}</div>
                  </div>
                </div>
                <div class="price" v-if="item.coupon_type == 2">
                  <span>{{item.amount}}折</span>
                </div>
                <div class="price" v-else>
                  ¥<span>{{item.amount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <img src="../assets/images/order-coupon-bottom1.png" width="100%" alt="">
          <div class="jump-btn" @click="closeCouponAlert()">立即使用</div>
        </div>
      </div>
    </div>
    <!--公告详情弹框-->
    <div class="notice_detail_alert" v-if="showNoticeAlert">
      <div class="notice_detail_content">
        <div class="notice_detail_bg">
          <h3>学校公告</h3>
          <div class="notice_detail_scroll">
            <p v-for="item of noticeList">{{ item }}</p>
            <!--<p>1.今天建桥学院俺来也校内定餐上线了，大家快来试试</p>-->
            <!--<p>2.新用户下单5折</p>-->
            <!--<p>3.一食堂停电了不支持线上</p>-->
            <!--<p>4.今天天气原因校车不开</p>-->
          </div>
        </div>
        <div class="close-btn" @click="showNoticeAlert = false"></div>
      </div>
    </div>
    <!--广告弹窗-->
    <div class="notice_detail_alert" v-if="showAdsvPop">
      <div class="notice_detail_content" style="width: 5.4rem;position: relative">
        <img :src="adsvPopItem.imageUrl" alt="" @click="bannerJump(adsvPopItem,'62','click_home_top_banner')">
        <wx-open-launch-weapp
          v-if="adsvPopItem.type == 500085"
          style="position: absolute;width: 100%;bottom:.85rem;top:0;left:0"

          :username="JSON.parse(adsvPopItem.data).miniProgramId"
          :path="JSON.parse(adsvPopItem.data).path">
          <script type="text/wxtag-template">
            <style>.btn{ position: absolute;top:0;left:0;width:100%;height:100%;opacity:0 }</style>
            <div class="btn"></div>
          </script>
        </wx-open-launch-weapp>
        <div class="close-btn" @click="closeAdsvPop"></div>
      </div>
    </div>
    <!--新学期领红包活动（2023.08.28）-->
    <div class="notice_detail_alert bonus" v-if="showBonusPop">
      <div class="notice_detail_content">
        <img :src="bonusPop.icon" alt="" @click="bonusPopJump()">
        <div class="close-btn" @click="showBonusPop = false"></div>
      </div>
    </div>
    <!-- 常驻活动入口 -->
    <div class="fixed-card" v-if="cardPlusInfo && cardPlusInfo.card">
      <img :src="cardPlusInfo.card" width="100%" @click="cardJump()"/>
    </div>
  </div>
</template>

<script>
// var wx = require('weixin-js-sdk')
import {actions} from '../store/actions'
import CommentStars from '../components/CommentStars'
// import { MessageBox , Indicator} from 'mint-ui'
import _ from "lodash";

export default {
  name: 'index',
  data() {
    return {
      showPage: false,
      showHomePage: false,
      isOpenA: true,
      tagList: [],
      shopList: [],
      schoolLock: false,
      banners: [],
      schoolInfo: {
        schoolId: 1237,
        schoolName: '华东理工'
      },
      shopCategoryList: [],
      currentShopList: [],
      currentPage: 1,
      pageSize: 20,
      showTag: true,
      hasMore: false,
      lanternSlideList: [],
      showBottomTips: false,
      showRecommend: false,//是否显示活动banner
      activity: '',
      showCouponAlert: false,
      couponInfo: {},
      originNoticeContent: '',//公告
      noticeContent: '',
      showNoticeAlert: false,//是否显示公告详情弹框
      noticeList: [],//公告详情数组
      adsvPopList: [], // 广告弹窗
      showAdsvPop: false,
      adsvPopItem: {},
      // adsvPopStatus: localStorage.getItem('adsvPopStatus') ? JSON.parse(localStorage.getItem('adsvPopStatus')) : {},
      uid: null,
      isYSF: false,
      isjdlw: false,
      isJdlwNewCustomer: 0,
      stillHeight: 0,
      remSize: 0,
      clientHeight: 0,
      scollTop: window.appScroll,

      showBonusPop: false, // 新学期红包
      bonusPop: {},
      cardPlusInfo: {},

      shopTitles: [
        {id: 0 ,title: '全部商家',checked: true},
        {id: 1 ,title: '活动店铺',checked: false},
        {id: 2 ,title: '买过的店',checked: false},
      ],
      shopSorts: [
        {id: 0 ,title: '综合排序',checked: true},
        {id: 1 ,title: '只看外卖',checked: false},
        {id: 2 ,title: '只看自提',checked: false},
        {id: 3 ,title: '只看堂食',checked: false},
      ],
      orderType: 0, //0-综合 1-外卖 2-自提 3-堂食
      currentTitle: 0, //0-全部商家 1-活动店铺 2-买过的店
      isFixed: false,
      headerHeight: 0,
      listOffsetTop: 0,
      noData: false,
      isClick: 0,

      benefitList: [],
      isOpenOrder: false,
    }
  },
  watch: {
    scollTop(val, old) {
      // console.log(val)
    }
  },
  beforeRouteLeave(to, from, next) {
    from.meta.isUseCache = false
    next()
  },
  activated() {
    if (!this.$route.meta.isUseCache) {
      var _this = this
      // document.title = '校内订餐'

      _this.showPage = false
      _this.banners = []
      _this.benefitList = []
      _this.showHomePage = false
      _this.tagList = []
      _this.shopList = []
      _this.currentPage = 1
      _this.shopCategoryList = []
      _this.currentShopList = []
      _this.cardPlusInfo = {}

      // 更新用户信息
      var token = window.localStorage.getItem('wxToken')
      if (_this.$utils.getCookie('token')) {
        token = _this.$utils.getCookie('token')
        var obj = {
          wxToken: token,
          wxUid: '',
          wxLoginToken: ''
        }
        _this.$store.commit('changeState', obj)

        window.localStorage.removeItem('userInfo')
        window.localStorage.removeItem('wxLoginToken')
        _this.updateUserInfo(token);
      }else{
        _this.$messagebox.alert('授权不成功，请退出重新进入', '')
        // return;
      }

      // 邀请有礼
      if(_this.$utils.getCookie('clc') && _this.$utils.getCookie('clc').length > 0){
        if(_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId){
          _this.$store.state.schoolInfo = {};
          _this.$store.commit('changeSchoolInfo', {});
        }
      }

      /**
       * 如果有指定学校id
       */
      let url_school_id = _this.$utils.resolveUrl().school_id
      if (!url_school_id && !_this.$store.state.schoolInfo && document.domain.indexOf('xiyoushi.com') >= 0) {
        var obj = {
          wxToken: _this.randomWord(false, 32),
        };
        _this.$store.commit('changeState', obj);
        url_school_id = 1826;
        window.localStorage.setItem('school_lock', '1')
      }

      if (url_school_id) {
        _this.schoolInfo.schoolId = url_school_id
        _this.getSchoolStatus(url_school_id)
      } else {
        if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
          _this.schoolInfo = _this.$store.state.schoolInfo
          _this.getSchoolStatus(_this.schoolInfo.schoolId)
        } else {
          _this.$router.push({path: `/chooseschool`})
          return false
        }
      }

      /**
       * 是否是单校区*/
      if (_this.$utils.resolveUrl().school_lock == undefined) {
        var school_lock = window.localStorage.getItem('school_lock')
        if (school_lock == '1') {
          _this.schoolLock = true
        } else {
          _this.schoolLock = false
        }
      } else {
        if (_this.$utils.resolveUrl().school_lock == 'true') {
          window.localStorage.setItem('school_lock', '1')
          _this.schoolLock = true
        } else {
          window.localStorage.setItem('school_lock', '2')
          _this.schoolLock = false
        }
      }

      // if (this.$utils.getCookie('source') && this.$utils.getCookie('source') == 'jdlw') {
      //   // 京东梨涡
      //   this.isjdlw = true
      // }
      // // 梨涡新老用户参数
      // if (this.$utils.getCookie('isNewCustomer') && this.$utils.getCookie('isNewCustomer') == 1) {
      //   // 京东梨涡
      //   this.isJdlwNewCustomer = 1
      // }

      if(_this.$store.state.wxLoginToken && _this.$store.state.wxLoginToken.length > 0){
        // 新学期领红包活动
        _this.isShowBonusPop();
        // 新学期礼券
        _this.isShowCoupon();
      }
    }
    let html = document.getElementsByTagName('html');
    if (html[0]) {
      let rem = html[0].style.fontSize;
      this.remSize = parseInt(rem);
      this.stillHeight = (this.stillHeight + this.remSize * 0.98)
    }
    this.clientHeight = document.documentElement.clientHeight;

    let shopList = document.getElementsByClassName("category-list");
    let lanternList = document.getElementsByClassName("lantern-list");
    let tagList = document.getElementsByClassName("tag-list");
    this.stillHeight = (this.stillHeight + this.remSize * 2.6);
    let goodsTitle = document.getElementsByClassName('goods-title');
    if (goodsTitle && goodsTitle[0]) {
      this.stillHeight = (this.stillHeight + goodsTitle[0].offsetHeight + this.remSize * 0.4);
    }
    if (shopList && shopList[0]) {
      this.stillHeight = (this.stillHeight + shopList[0].offsetHeight + this.remSize * 0.3);
    }
    if (lanternList && lanternList[0]) {
      this.stillHeight = this.stillHeight + lanternList[0].offsetHeight;
    }
    if (tagList && tagList[0]) {
      this.stillHeight = (this.stillHeight + tagList[0].offsetHeight + this.remSize * 0.2);
    }
    let goodsList = document.getElementsByClassName('goods-ul');
    if (goodsList && goodsList[0]) {
      let item = (Math.round(goodsList[0].offsetHeight / this.currentShopList.length));
      if (localStorage.getItem('wxUid')) {
        localStorage.setItem('recordLogIdx', 0)
      }
      this.$store.commit('changeRecordItemHeight', item);
      this.$store.commit('changeRecordList', this.currentShopList);
    }
    this.$store.commit('changeRecordOtherHeight', this.stillHeight);
    this.$store.commit('changeRecordPage', 'TagPage');
    this.$store.commit('changeRecordState', true);

    // 自定义分享
    let host = this.$utils.getHost();
    let link = this.$utils.isWxWork() ? host + '/wxWork' : this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=sch' + this.schoolInfo.schoolId;
    this.$utils.wxShareNew(
      this,
      '【俺来也】校内订餐，暖心服务', // 分享标题
      link, // 分享链接
      host + '/share.png', // 分享图标
      '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
    );
    if (document.domain == 'www.xiyoushi.com' || document.domain == 'xiyoushi.com') {
       _this.showBottomTips = true
       document.title = '西游食'
    }
  },
  mounted() {
    var _this = this;
    this.$store.commit('changeRecordPage', 'TagPage');
    this.$store.commit('changeRecordState', true);
    window.addEventListener('scroll', this.handleScroll)
    // 页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight -
          (document.documentElement.scrollTop + document.body.scrollTop) -
          document.documentElement.clientHeight
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight
      }
      if (marginBot <= 0) {
        if (_this.hasMore) {
          if(_this.currentTitle == 0){ //全部商家
            _this.getShopList()
          }else if(_this.currentTitle == 1){
            _this.getPromtionShop() //活动店铺
          }else {
            _this.getBoughtShop() //买过的店
          }
        }
      }
    }
    window.localStorage.setItem('upSDKUrl', window.location.href);

    let html = document.getElementsByTagName('html');
    if (html[0]) {
      let rem = html[0].style.fontSize;
      this.remSize = parseInt(rem);
      this.stillHeight = (this.stillHeight + this.remSize * 0.98)
    }
    this.clientHeight = document.documentElement.clientHeight;
    this.$store.commit('changeRecordOtherHeight', this.stillHeight);
  },
  methods: {
    // 获取学校状态
    getSchoolStatus(url_school_id) {
      var _this = this;
      actions.postSchoolStatus(_this, {school_id: url_school_id}, function (data) {
        let schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        }
        _this.isOpenOrder = data.three_meals_status == 1 ? true : false
        _this.$store.commit('changeSchoolInfo', schoolInfo)
        _this.schoolInfo = schoolInfo
        _this.getHomeStatus()
        _this.getBanner() // 顶部banner
        _this.getNotice() // 公告
        _this.getLanternSlideList() // 幻灯片
        _this.getAdsvcPop() // 广告弹窗
        // _this.isShowRecommend() // 是否显示推荐下单领红包的bannner
        _this.getCardPlus() // 常驻活动入口
        _this.getBenefitList(); //商家权益包
        _this.$utils.setCookie('alySchoolId', _this.schoolInfo.schoolId)
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    updateUserInfo(token) {
      var _this = this;
      actions.postAuthInfo(_this, {token: token}, function (data) {
        let openid = _this.$store.state.openId
        if (data.openid && data.openid != '') {
          openid = data.openid
        }
        if(data.login_token){
          let obj = {
            openId: openid,
            wxUid: data.uid,
            wxToken: data.token,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          }
          _this.$store.commit('changeState', obj)

          let userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex,
            mp_real: _this.$utils.Decrypt(data.mp_encryption),
          }
          _this.$store.commit('changeUserInfo', userInfo)
          if(_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId){
            // 新学期领红包活动
            _this.isShowBonusPop();
            // 新学期礼券
            _this.isShowCoupon();
          }
        }
      }, function () {

      })
    },
    // 分享
    weixinShare() {
      var _this = this
      var u = encodeURIComponent(window.location.href.split('#')[0])
      window.localStorage.setItem('landingPage', u)
      actions.getJsShareConf(_this, u, function (data) {
        let host = _this.$utils.getHost()
        wx.config({
          debug: false,
          appId: data.data.appId,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: data.data.jsApiList
        })
        let link = _this.$utils.isWxWork() ? host + '/wxWork' : _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=sch' + _this.schoolInfo.schoolId
        wx.ready(function () {
          _this.$utils.wx_share(
            '【俺来也】校内订餐，暖心服务', // 分享标题
            link, // 分享链接
            host + '/share.png', // 分享图标
            '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
          );
        })
      })
    },
    // 统计埋点
    addLog(param) {
      // 内部统计
      var _this = this;
      var params = param || {
        logDetails: [{
          uid: _this.$store.state.wxUid,
          code: 'aly_main_index_display',
          createTime: new Date().getTime(),
          firstValue: this.$utils.getCookie('UM_distinctid')
        }]
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    },
    //生成32位token
    randomWord(randomFlag, min, max) {
      var str = "",
        range = '',
        pos = '',
        range = min,
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },
    //开学季红包 弹窗礼券
    isShowCoupon() {
      let _this = this
      let params = {
        token: _this.$store.state.wxLoginToken,
        uid: _this.$store.state.wxUid,
        mp: _this.$store.state.userInfo.mp_real,
        school_id: _this.schoolInfo.schoolId,
        isNewCustomer: _this.isJdlwNewCustomer
      }
      if (_this.isjdlw) {
        params.source = 'jdlw';
      }
      actions.showCoupon(_this, params, function (res) {
        if (res != null && res != 'null') {
          for (let item of res.list) {
            if (item.coupon_begin_time && item.coupon_end_time) {
              item.coupon_begin_time = item.coupon_begin_time.substr(0, 10)
              item.coupon_end_time = item.coupon_end_time.substr(0, 10)
            }
          }
          _this.showCouponAlert = true
          _this.couponInfo = res
          var params = {
            logDetails: [{
              uid: _this.$store.state.wxUid || '',
              code: 'asa_popbonus_index',
              createTime: new Date().getTime(),
              firstValue: _this.schoolInfo.schoolId
            }]
          }
          _this.addLog(params)
        } else {
          _this.showCouponAlert = false
        }
      }, function () {
        _this.showCouponAlert = false
      })
    },
    closeCouponAlert() {
      this.showCouponAlert = false;
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid || '',
          code: 'click_popbonus_index',
          createTime: new Date().getTime(),
          firstValue: _this.schoolInfo.schoolId
        }]
      }
      this.addLog(params)
    },
    // 新学期红包
    isShowBonusPop() {
      let _this = this
      let params = {
        login_token: _this.$store.state.wxLoginToken,
        school_id: _this.schoolInfo.schoolId
      }
      actions.postPopBonusShow(_this, params, function (res) {
        if(res && res.business_jump_data){
          res.business_jump_data = JSON.parse(res.business_jump_data);
          _this.bonusPop = res;
          _this.showBonusPop = true;
          var params = {
            logDetails: [{
              uid: _this.$store.state.wxUid || '',
              code: 'asa_ad_popbonus_index',
              createTime: new Date().getTime(),
              firstValue: _this.schoolInfo.schoolId,
              secondValue: res.business_type
            }]
          }
          _this.addLog(params)
        }
      }, function () {

      })
    },
    bonusPopJump() {
      if(this.bonusPop.business_type == 1022){
        if(!this.$utils.getCookie('alywechatToken')){
          location.href = this.bonusPop.business_jump_data.url + '?token='+this.$store.state.wxLoginToken;
        }else{
          location.href = this.bonusPop.business_jump_data.url;
        }
      }
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid || '',
          code: 'click_ad_popbonus_index',
          createTime: new Date().getTime(),
          firstValue: _this.schoolInfo.schoolId,
          secondValue: this.bonusPop.business_type
        }]
      }
      this.addLog(params)
    },
    // 推荐下单活动
    isShowRecommend() {
      let _this = this
      actions.recommendBanner(_this, {}, function (res) {
        if (res != null) {
          _this.showRecommend = true
          _this.activity = res
        } else {
          _this.showRecommend = false
        }
      }, function () {

      })
    },
    toRecommend(item) {
      let obj = JSON.parse(item.data)
      if (obj.isNeedLogin) {
        var uid = this.$store.state.wxUid
        if (uid == 'null' || uid == '' || uid == null) { // 如果没有登录信息先跳转登录页
          // this.$router.push({name: 'Login'})
          this.$utils.toLogin(this);
        } else {
          let token = this.$store.state.wxLoginToken
          let uid = this.$store.state.wxUid
          let schoolId = this.schoolInfo.schoolId
          let url = obj.url + '?token=' + token + '&uid=' + uid + '&schoolId=' + schoolId
          window.location.href = url
        }
      } else {
        window.location.href = obj.url
      }

    },
    showMoreGift: function (item) {
      item.iShowMore = !item.iShowMore;
    },
    // 公告
    getNotice: function () {
      let _this = this;
      let params = {
        school_id: _this.schoolInfo.schoolId
      }

      actions.getNoticeInfo(_this, params, function (data) {
        if (data && data.content) {
          // _this.noticeContent = data.content
          let noticeContent = data.content
          _this.originNoticeContent = data.content
          _this.noticeContent = noticeContent.replace(/<br\/>/g, ' ')
        }
      })
    },
    //公告弹框
    getNoticeDetail() {
      this.noticeList = this.originNoticeContent.split('<br/>');
      this.showNoticeAlert = true;
    },
    // 广告弹窗
    getAdsvcPop: function () {
      var _this = this
      var url
      let host = _this.$utils.getSpliceHost('adsvc')
      url = host + '/ad/app/getList.do'
      var params = {
        app_version: '5.3',
        client_type: 3,
        device_id: '123',
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: '62'
      }
      _this.$http.post(url, params).then(function (response) {
        // _this.adsvPopList = response.data.data.list
        // if (_this.adsvPopList.length > 0) {
        //   if (JSON.stringify(_this.adsvPopStatus) === '{}' || (_this.adsvPopStatus && !_this.adsvPopStatus.isClickClose) || (_this.adsvPopStatus && _this.adsvPopStatus.isClickClose && _this.adsvPopStatus.adsvId != _this.adsvPopList[0].adId)) {
        //     _this.showAdsvPop = true
        //   }
        // }
        if(response.data.data.list && response.data.data.list.length > 0){
          // 0-每次启动都弹出 1-每日首次启动弹出一次 2-按设备仅弹出一次
          let lastDisplay = localStorage.getItem('lastDisplay'), // 已经展示过
            list = response.data.data.list,
            lastDisplayIds = [];
          if(lastDisplay && lastDisplay.length > 0){
            lastDisplay = JSON.parse(lastDisplay);
            for(let v1 of lastDisplay){
              for(let v2 of list){
                // 判断每日首次
                if(v1.frequency === 1 && v2.adId == v1.adId){
                  let today = new Date();
                  today.setHours(0);
                  today.setMinutes(0);
                  today.setSeconds(0);
                  today.setMilliseconds(0);
                  let otime = today.getTime();
                  let offset= v1.time - otime;
                  let isToday = offset/1000/60/60;
                  if(isToday < 0 && isToday <= -24){
                    // 昨天
                    v1.needDelete = true;
                  }
                }
                if(v1.frequency != v2.frequency && v2.adId == v1.adId){
                  v1.needDelete = true;
                }
              }
            }
            // 判断每次启动都弹出
            if(lastDisplay.length >= list.length){
              let n2 = 0, n3 = 0;
              for(let v1 of lastDisplay){
                for(let v2 of list){
                  if(v2.frequency === 0 && v2.adId == v1.adId){
                    n2++;
                  }
                }
              }
              for(let v2 of list){
                if(v2.frequency === 0){
                  n3++;
                }
              }
              if(n2 == n3){
                let array = [];
                lastDisplay.map((el, index) => {
                  if (!list.find(item => item.adId == el.adId)) {
                    array.push(lastDisplay[index]);
                  }
                })
                lastDisplay = array;
              }
            }
            let temp = [];
            for(let v1 of lastDisplay){
              if(!v1.needDelete){
                temp.push(v1);
              }
            }
            lastDisplay = temp;
            lastDisplay.forEach((v) => {
              lastDisplayIds.push(v.adId);
            })
            for(let v of list){
              if(lastDisplayIds.indexOf(v.adId) == -1){
                if(v.frequency === 0 || v.frequency === 1 || v.frequency === 2){
                  lastDisplay.push({
                    adId: v.adId,
                    frequency: v.frequency,
                    time: new Date().getTime()
                  })
                  this.isShowPop(v);
                  break;
                }
              }
            }
          }else{
            for(let i = 0; i < list.length; i++){
              if(i == 0){
                lastDisplay = [];
                lastDisplay.push({
                  adId: list[i].adId,
                  frequency: list[i].frequency,
                  time: new Date().getTime()
                })
                this.isShowPop(list[i]);
              }
            }
          }

          if(lastDisplay.length > 100){
            lastDisplay = [];
          }
          localStorage.setItem('lastDisplay', JSON.stringify(lastDisplay));
        }
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      })
    },
    isShowPop: function(item) {
      this.showAdsvPop = true;
      this.adsvPopItem = item;
    },
    closeAdsvPop: function () {
      this.showAdsvPop = false;
    },
    getBanner: function () {
      var _this = this
      var url
      let host = _this.$utils.getSpliceHost('adsvc')
      url = host + '/ad/app/getList.do'
      var params = {
        app_version: '5.3',
        client_type: 3,
        device_id: '123',
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: '118'
      }
      _this.$http.post(url, params).then(function (response) {
        _this.banners = response.data.data.list

        if (_this.banners.length > 1) {
          setTimeout(function () {
            var mySwiper = new Swiper('.swiper-container.banner-container', {
              pagination: '.pagination',
              speed: 2000,
              loop: true,
              autoplay: 4000,
              onTap: function (swiper, e) {
                let index = (swiper.activeIndex - 1) % (_this.banners.length);
                //顶部轮播广告位的点击
                _this.bannerJump(_this.banners[index],'118','click_home_top_banner')
              }
              // autoplay: {
              //   delay: 4000,//4秒切换一次
              //   stopOnLastSlide: false,//如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）
              //   disableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止。
              //   reverseDirection: false,//不开启反向自动轮播。
              // }
            })
          },700)
        }

        let uid = localStorage.getItem('wxUid');
        if (uid) {
          let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
          exposureLog = exposureLog ? exposureLog : [];
          for (let k = 0; k < _this.banners.length; k++) {
            //顶部轮播广告位的曝光
            exposureLog.push({
              uid: uid == 'undefined' ? 0 : uid,
              refId: _this.banners[k].adId,
              firstValue: _this.schoolInfo.schoolId,
              secondValue: _this.banners[k].type || '',
              thirdValue:  '118',
              createTime: new Date().getTime(),
              code: 'asa_home_top_banner',
            })
          }
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      })
    },
    bannerJump: function (item,locationId,code) {
      var _this = this
      if (item.data && item.data != '{}') {
        var jump = JSON.parse(item.data)
        if (jump.isNeedLogin && jump.isNeedLogin == 'true') {
          var uid = _this.$store.state.wxUid
          if (uid == 'null' || uid == '' || uid == null) { // 如果没有登录信息先跳转登录页
            // _this.$router.push({name: 'Login'})
            _this.$utils.toLogin(_this);
            return;
          }
        }
        if (item.type == 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          }
          _this.$store.commit('changeState', obj)
          this.$router.push({name: 'ShopList'})
        } else if (item.type == 500086) {
          // 活动店铺
          var obj = {
            category_name: jump.title,
            tag_id: jump.key_id,
            shopListType: 'activity'
          }
          _this.$store.commit('changeState', obj)
          this.$router.push({name: 'ShopList'})
        } else if (item.type == 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            // 临时加
            if(jump.url.indexOf('bonus') > -1){
              var uid = _this.$store.state.wxUid
              if (uid == 'null' || uid == '' || uid == null) { // 如果没有登录信息先跳转登录页
                // _this.$router.push({name: 'Login'})
                _this.$utils.toLogin(_this);
              }else{
                if(!this.$utils.getCookie('alywechatToken')){
                  location.href = jump.url + '?token='+this.$store.state.wxLoginToken;
                }else{
                  location.href = jump.url;
                }
              }
            }else{
              window.location.href = jump.url
            }
          }
        } else if (item.type == 500071) {
          var obj = {
            shop_code: jump.key_id,
            shop_name: jump.key_title,
            showBlockType: 'orderDishes'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'GoodsList'})
        }
      }
      var logDetails = [{
        uid: _this.$store.state.wxUid,
        code: code,
        createTime: new Date().getTime(),
        refId: item.adId || '',
        firstValue: _this.schoolInfo.schoolId,
        secondValue: item.type || '',
        thirdValue: locationId
      }]
      _this.addLog1(logDetails)
      // _this.getScoreClickAd()
    },
    //点击埋点
    addLog1(list) {
      let _this = this;
      let params = {
        logDetails: list,
        source: 3,
      };
      actions.postLogAdd(_this, params,(res) => {
        console.log('success');
      },function () {

      })
    },
    getLanternSlideList: function () {
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId
      }
      actions.getLanternSlide(_this, params, function (data) {
        _this.lanternSlideList = data;
        let uid = localStorage.getItem('wxUid');
        if (uid) {
          let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
          exposureLog = exposureLog ? exposureLog : [];
          for (let k = 0; k < data.length; k++) {
            //中间广告位的曝光
            exposureLog.push({
              uid: uid == 'undefined' ? 0 : uid,
              refId: data[k].id,
              firstValue: data[k].school_id,
              secondValue: data[k].app_jump_type || '',
              thirdValue: data[k].position || '',
              createTime: new Date().getTime(),
              code: 'asa_home_top_banner',
            })
          }
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      })
    },
    lanternSlideJump: function (item) {
      var _this = this
      if (item.app_jump_params && item.app_jump_params != '{}') {
        var jump = JSON.parse(item.app_jump_params)
        if (item.app_jump_type == 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'ShopList'})
        } else if (item.app_jump_type == 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            window.location.href = jump.url
          }
        } else if (item.app_jump_type == 500071) {
          var obj = {
            shop_code: item.jump_target,
            shop_name: item.show_name,
            showBlockType: 'orderDishes'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'GoodsList'})
        } else if (item.app_jump_type == 500095) {
          _this.$router.push({name: 'CouponPackage'})
        }
        //中间广告位点击埋点
        var logDetails = [{
          uid: _this.$store.state.wxUid,
          code: 'click_home_top_banner',
          createTime: new Date().getTime(),
          refId: item.id,
          firstValue: _this.schoolInfo.schoolId,
          secondValue: item.app_jump_type || '',
          thirdValue: item.position
        }]
        _this.addLog1(logDetails)
      }
      // _this.getScoreClickAd()
    },
    // 判断是否展示A页面
    getHomeStatus: function () {
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId
      }
      actions.getHomeStatus(_this, params, function (data) {
        if (data.home_status == 1) {
          // 展示A页
          _this.isOpenA = true
          _this.getShowList()
        } else {
          _this.isOpenA = false
          _this.getHomePageInfo();
          _this.getShopList();
        }
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '')
        // 响应错误回调
      })
    },
    // 获取A页面内容（球和食堂列表）
    getShowList: function () {
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId
      }
      _this.$indicator.open({
        text: '努力加载中',
      });
      actions.getTagIndexList(_this, params, function (data) {
        _this.tagList = data.ball
        _this.shopList = data.list
        _this.showPage = true
        // _this.getNotice();
        _this.$indicator.close();

        _this.$nextTick(() => {
          let shopList = document.getElementsByClassName("category-list");
          let lanternList = document.getElementsByClassName("lantern-list");
          let tagList = document.getElementsByClassName("tag-list");
          _this.stillHeight = _this.remSize * 3.58
          if (shopList && shopList[0]) {
            _this.stillHeight = (_this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3);
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = (_this.stillHeight + lanternList[0].offsetHeight + _this.remSize * 0.2);
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = (_this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2);
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          let goodsList = document.getElementsByClassName('goods-ul');
          // console.log(_this.stillHeight)
          if (goodsList && goodsList[0]) {
            let item = (Math.round(goodsList[0].offsetHeight / _this.shopList.length));
            if (localStorage.getItem('wxUid')) {
              localStorage.setItem('recordLogIdx', 0)
            }
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            localStorage.setItem('recordLogIdx', 0);
            _this.$store.commit('changeRecordPage', 'TagPage2');
            _this.$store.commit('changeRecordState', true);
            let uid = localStorage.getItem('wxUid');
            if (uid) {
              let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
              exposureLog = exposureLog ? exposureLog : [];
              //A页面球曝光
              for (let k = 0; k < data.ball.length; k++) {
                exposureLog.push({
                  uid: uid == 'undefined' ? 0 : uid,
                  refId: data.ball[k].id,
                  firstValue: data.ball[k].school_id,
                  createTime: new Date().getTime(),
                  code: 'asa_home_ball_scroll',
                })
              }
              localStorage.setItem('lastLogTime', new Date().getTime());
              localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
            }
          }
        })
      }, function (data) {
        _this.showPage = true
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '')
        // 响应错误回调
      })
    },
    toGoHomePage: function (item, n) {
      var _this = this
      let jump_type = item.app_jump_type;
      if (item.app_jump_params && item.app_jump_params != '{}') {
        let jump_params = JSON.parse(item.app_jump_params);
        if (jump_type == 500072) {
          // 店铺标签
          var obj = {
            category_name: jump_params.key_title,
            tag_id: jump_params.key_id,
            shopListType: 'tag'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'ShopList'})
        } else if (jump_type == 500071) {
          // 店铺详情页面
          var obj = {
            shop_code: jump_params.key_id,
            shop_name: jump_params.key_title,
            showBlockType: 'orderDishes'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'GoodsList'})
        } else if (jump_type == 600007) {
          var obj = {
            category_code: jump_params.key_id,
            category_name: jump_params.key_title,
            shopListType: 'category'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'ShopList'})
        } else if (jump_type == 1022) {
          // h5
          if (jump_params.url) {
            window.location.href = jump_params.url;
          }
        }
      }

      // if (item.jump_type == 1) {
      //   var obj = {
      //     category_name: item.show_name,
      //     tag_id: item.jump_target,
      //     shopListType: 'tag'
      //   }
      //   _this.$store.commit('changeState', obj)
      //   this.$router.push({name: 'ShopList'})
      // } else if (item.jump_type == 4) {
      //   var obj = {
      //     shop_code: item.jump_target,
      //     shop_name: item.show_name,
      //     showBlockType: 'orderDishes'
      //   }
      //   _this.$store.commit('changeState', obj)
      //   _this.$router.push({name: 'GoodsList'})
      // } else {
      //   window.location.href = item.jump_target;
      // }
      // 埋点
      var clickParams
      if (n) {
        // A球点击埋点
        var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'click_home_ball',
            refId: item.id,
            firstValue: item.school_id,
            secondValue: item.app_jump_type || '',
            createTime: new Date().getTime()
        }]
        _this.addLog1(clickParams)
      } else {
        clickParams = {
          logDetails: [{
            uid: _this.$store.state.wxUid,
            code: 'click_takeout_indexa_school_refectory',
            createTime: new Date().getTime(),
            refId: jump_type,
            firstValue: _this.schoolInfo.schoolId
          }]
        }
        _this.addLog(clickParams)
      }
    },
    chooseSchool: function () {
      this.$router.push({path: '/chooseschool'})
    },
    toSearch: function () {
      var _this = this
      _this.$router.push({name: 'Search'})
    },
    // 非A页面球列表
    getHomePageInfo: function () {
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: 1,
        pageSize: 1000
      }
      _this.$indicator.open({
        text: '努力加载中',
      });
      // 获取店铺分类列表
      actions.postShopCategoryList(_this, params, function (data) {
        if (data && data.length > 0) {
          var list = []
          for (let shop of data) {
            let obj = {
              backgroundImage: 'url(' + shop.show_icon + ')'
            }
            shop.backgroundimg = obj
            list.push(shop)
          }
          _this.shopCategoryList = list;
          _this.$nextTick(() => {
            let uid = localStorage.getItem('wxUid');
            if (uid) {
              let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
              exposureLog = exposureLog ? exposureLog : [];
              for (let k = 0; k < list.length; k++) {
                //非A页球曝光
                exposureLog.push({
                  uid: _this.$store.state.wxUid,
                  code: 'asa_home_ball_scroll',
                  createTime: new Date().getTime(),
                  refId: list[k].id,
                  firstValue: _this.schoolInfo.schoolId,
                })
              }
              localStorage.setItem('lastLogTime', new Date().getTime());
              localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
            }
          })
        }
      }, function (data) {
        _this.showPage = true
        _this.$indicator.close();
        // _this.$messagebox.alert(data.body.message, '')
      })
    },
    handleScroll(){
      // 得到页面滚动的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置
      let val = scrollTop >= (this.listOffsetTop - this.headerHeight*2.5);
      this.isFixed =  val
    },
    getBenefitList: function(){
      var _this = this
      var params = {
        school_id: _this.schoolInfo.schoolId,
      }
      actions.getBenefitList(_this, params, function (data) {
        if(data && data.length > 0) {
          for(let item of data){
            if(item.promotion_list && item.promotion_list.length){
              if(item.promotion_list.length > 3 && item.promotion_package && item.promotion_package.length){
                item.promotion_reduce.splice(2)
                item.coupon_list = []
              }
              if(item.promotion_list.length < 3 && !item.promotion_package.length && item.promotion_reduce.length > 4){
                item.coupon_list.splice(2)
              }
              if(item.promotion_list.length == 1 && !item.promotion_package && !item.promotion_reduce && !item.coupon_list){
                item.showMsg = true
              }
            }
            if(item.promotion_package.length && item.promotion_reduce && item.promotion_reduce.reduce_info && item.promotion_reduce.reduce_info.length && item.coupon_list.length){
              item.coupon_list = []
            }
          }
          // _this.benefitList = data.concat(data)
          _this.benefitList = data
          _this.record1('','','asa_index');
          _this.record1(_this.benefitList[0].id, '', 'asa_index_shop');
          for (let i = 0; i < _this.benefitList[0].goods.length; i++) {
            _this.record1('', _this.benefitList[0].goods[i].gdCode, 'asa_index_gd_area'); //菜品位置曝光
          }
          let uid = localStorage.getItem('wxUid');
          if (_this.benefitList.length > 1) {
            setTimeout(function () {
              var mySwiper = new Swiper('.swiper-container.benefit-container', {
                speed: 2000,
                loop: false,
                autoplay: 4000,
                observer: true,
                observeParents: true,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
                onTap: function (swiper, e) {
                  //商家权益轮播的点击
                  let data = _this.benefitList[swiper.activeIndex]
                  _this.record1(data.id,'','asa_index_shop');
                  //菜品位置曝光
                  for(let i = 0;i < data.goods.length;i++){
                    _this.record1('', data.goods[i].gdCode,'asa_index_gd_area');
                  }
                }
              })
            },300)
          }
        }
      },function (data) {
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    benefitJump: function(val){
      var _this = this
      var obj = {
        shop_code: val.id,
        shop_name: val.shop_name,
        showBlockType: 'orderDishes'
      }
      _this.record1(val.id, '' ,'click_index_shop');
      _this.$store.commit('changeState', obj)
      _this.$router.push({name: 'GoodsList'})
    },
    goodsJump: function(val,item){
      var _this = this
      var obj = {
        shop_code: val.id,
        shop_name: val.shop_name,
        showBlockType: 'orderDishes'
      }
      _this.record1('', item.gdCode ,'click_index_gd_area');
      _this.$store.commit('changeState', obj)
      _this.$router.push({path: `/goodsList?gdCode=${item.gdCode}`})
    },
    //选择商家分类
    switchTitle: function(val){
      for (let v of this.shopTitles) {
        v.checked = false;
        if (v.id == val.id) {
          v.checked = true;
        }
      }
      this.shopSorts =  [
        {id: 0 ,title: '综合排序',checked: true},
        {id: 1 ,title: '只看外卖',checked: false},
        {id: 2 ,title: '只看自提',checked: false},
        {id: 3 ,title: '只看堂食',checked: false},
      ]
      this.currentPage = 1;
      this.page_size = 20;
      this.hasMore = false;
      this.noData = false;
      this.currentShopList = []
      this.orderType = 0;
      this.currentTitle = val.id;
      this.isClick = 1
      if(val.id == 0){ //全部商家
        this.getShopList()
      }else if(val.id == 1){
        this.getPromtionShop()
      }else{
        this.getBoughtShop()
      }
      this.record2('click_index', '');
    },
    switchSort: function(val){
      for (let v of this.shopSorts) {
        v.checked = false;
        if (v.id == val.id) {
          v.checked = true;
        }
      }
      this.currentPage = 1;
      this.page_size = 20;
      this.hasMore = false;
      this.noData = false;
      this.currentShopList = []
      this.orderType = val.id;
      this.isClick = 2
      this.getShopList()
      this.record2('click_index', '');
    },
    getPromtionShop: function() {
      var _this = this
      _this.hasMore = false
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize
      }
      actions.getPromtionList(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false
          } else {
            _this.hasMore = true
          }
          _this.currentPage = _this.currentPage + 1
          for (let shop of data) {
            let obj = {
              backgroundImage: 'url(' + shop.pic + ')'
            }
            shop.backgroundimg = obj
            shop.iShowMore = false
            if(shop.promotion_list && shop.promotion_list.length > 0){
              if(shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list){
                shop.showMsg = true
              }
              shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
            }
            _this.currentShopList.push(shop)
            _this.record(); //店铺的曝光
          }
        } else {
          _this.hasMore = false
          _this.noData = true
        }
        _this.showPage = true
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(() => {
          let shopList = document.getElementsByClassName("category-list");
          let lanternList = document.getElementsByClassName("lantern-list");
          let tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = (_this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3);
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = (_this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2);
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          let goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            let item = (Math.round(goodsList[0].offsetHeight / _this.currentShopList.length));
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }
          let header = document.getElementById("header");
          let list = document.getElementById('goods-list');

          // 这里要得到top的距离和元素自身的高度
          if(list){
            _this.listOffsetTop = list.offsetTop
          }
          if(header){
            _this.headerHeight =  header.offsetHeight
          }
        })
      }, function (data) {
        _this.showPage = true
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    getBoughtShop: function() {
      var _this = this
      _this.hasMore = false
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize
      }
      actions.getBoughtList(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false
          } else {
            _this.hasMore = true
          }
          _this.currentPage = _this.currentPage + 1
          for (let shop of data) {
            let obj = {
              backgroundImage: 'url(' + shop.pic + ')'
            }
            shop.backgroundimg = obj
            shop.iShowMore = false
            if(shop.promotion_list && shop.promotion_list.length > 0){
              if(shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list){
                shop.showMsg = true
              }
              shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
            }
            _this.currentShopList.push(shop)
            _this.record(); //店铺的曝光
          }
        } else {
          _this.hasMore = false
          _this.noData = true
        }
        _this.showPage = true
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(() => {
          let shopList = document.getElementsByClassName("category-list");
          let lanternList = document.getElementsByClassName("lantern-list");
          let tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = (_this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3);
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = (_this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2);
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          let goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            let item = (Math.round(goodsList[0].offsetHeight / _this.currentShopList.length));
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }
          let header = document.getElementById("header");
          let list = document.getElementById('goods-list')

          // 这里要得到top的距离和元素自身的高度
          if(list){
            _this.listOffsetTop = list.offsetTop
          }
          if(header){
            _this.headerHeight =  header.offsetHeight
          }
        })
      }, function (data) {
        _this.showPage = true
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    record() {
      let indexId = 200;
      if(this.currentTitle == 0 && this.isClick == 1){
        indexId = 200
      }else if(this.currentTitle == 1){
        indexId = 201
      }else if(this.currentTitle == 2){
        indexId = 202
      }
      if(this.orderType == 1){
        indexId = 204
      }else if(this.orderType == 2){
        indexId = 205
      }else if(this.orderType == 3){
        indexId = 206
      }else if(this.orderType == 0 && this.isClick == 2){
        indexId = 203
      }
      localStorage.setItem('indexId',indexId)
    },
    record1(id,gd_code,code) {
      let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
      exposureLog = exposureLog ? exposureLog : [];
      exposureLog.push({
        uid: localStorage.getItem('wxUid') || '',
        secondValue: 207,
        firstValue: this.schoolInfo.schoolId,
        refId: id ? id: gd_code,
        createTime: new Date().getTime(),
        code: code,
      })
      this.addLog1(exposureLog)
    },
    record2(code,id){
      let indexId;
      if(this.currentTitle == 0 && this.isClick == 1){
        indexId = 200
      }else if(this.currentTitle == 1){
        indexId = 201
      }else if(this.currentTitle == 2){
        indexId = 202
      }
      if(this.orderType == 1){
        indexId = 204
      }else if(this.orderType == 2){
        indexId = 205
      }else if(this.orderType == 3){
        indexId = 206
      }else if(this.orderType == 0 && this.isClick == 2){
        indexId = 203
      }
      let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
      exposureLog = exposureLog ? exposureLog : [];
      exposureLog.push({
        uid: localStorage.getItem('wxUid') || '',
        secondValue: indexId,
        firstValue: this.schoolInfo.schoolId,
        refId: id ? id :'',
        createTime: new Date().getTime(),
        code: code,
      })
      this.addLog1(exposureLog)
    },
    // 非A页面商家列表
    getShopList: function () {
      var _this = this
      _this.hasMore = false
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize,
        orderType: _this.orderType,
        sort_type: 0
      }
      // 获取当前校区商家列表
      actions.getShopListNew(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false
          } else {
            _this.hasMore = true
          }
          _this.currentPage = _this.currentPage + 1
          for (let shop of data) {
            let obj = {
              backgroundImage: 'url(' + shop.pic + ')'
            }
            shop.backgroundimg = obj
            shop.iShowMore = false
            if(shop.promotion_list && shop.promotion_list.length > 0){
              if(shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list){
                shop.showMsg = true
              }
              shop.promotion_list = _.uniqBy(shop.promotion_list, item => item.promotion_type);
            }
            _this.currentShopList.push(shop)
          }
          _this.record(); //店铺的曝光
        } else {
          _this.hasMore = false
          _this.noData = true
        }
        _this.showPage = true
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(() => {
          let shopList = document.getElementsByClassName("category-list");
          let lanternList = document.getElementsByClassName("lantern-list");
          let tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = (_this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3);
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = (_this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2);
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          let goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            let item = (Math.round(goodsList[0].offsetHeight / _this.currentShopList.length));
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }

          let header = document.getElementById("header");
          let list = document.getElementById('goods-list')
          // 这里要得到top的距离和元素自身的高度
          if(list){
            _this.listOffsetTop = list.offsetTop
          }
          if(header){
            _this.headerHeight =  header.offsetHeight
          }
        })
      }, function (data) {
        _this.showPage = true
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '')
      })
    },
    toGoodsList: function (id, name) {
      var _this = this
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      }
      _this.$store.commit('changeState', obj)
      _this.$router.push({name: 'GoodsList'})
      // 埋点
      this.record2('click_index_shop',id);
    },
    toShopList: function (item) {
      var _this = this
      let jump_type = item.app_jump_type;
      if (item.app_jump_params && item.app_jump_params != '{}') {
        let jump_params = JSON.parse(item.app_jump_params);
        if (jump_type == 500072) {
          // 店铺标签
          var obj = {
            category_name: jump_params.key_title,
            tag_id: jump_params.key_id,
            shopListType: 'tag'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'ShopList'})
        } else if (jump_type == 500071) {
          // 店铺详情页面
          var obj = {
            shop_code: jump_params.key_id,
            shop_name: jump_params.key_title,
            showBlockType: 'orderDishes'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'GoodsList'})
        } else if (jump_type == 600007) {
          var obj = {
            category_code: jump_params.key_id,
            category_name: jump_params.key_title,
            shopListType: 'category'
          }
          _this.$store.commit('changeState', obj)
          _this.$router.push({name: 'ShopList'})
        } else if (jump_type == 1022) {
          // h5
          if (jump_params.url) {
            window.location.href = jump_params.url;
          }
        }
      }
      // 非A球点击埋点
      var clickParams = [{
        uid: _this.$store.state.wxUid,
        code: 'click_home_ball',
        refId: item.id,
        firstValue: item.school_id,
        secondValue: item.app_jump_type || '',
        createTime: new Date().getTime()
      }]
      _this.addLog1(clickParams)
    },
    //右下悬浮块
    clickLog(jumpType,code){
      var _this = this;
      var logs = [{
        uid: _this.$store.state.wxUid,
        firstValue: _this.schoolInfo.schoolId,
        secondValue: jumpType,
        createTime: new Date().getTime(),
        code: code,
      }]
      actions.postLogAdd(_this, logs, function (data) {
        console.log('记录成功');
      }, function (data) {

      })
    },

    // 活动常驻入口
    getCardPlus() {
      let _this = this
      let params = {
        school_id: _this.schoolInfo.schoolId
      }
      actions.postCardPlus(_this, params, function (res) {
        if(res && res.card){
          _this.cardPlusInfo = res;
          var logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_app_suspend',
            createTime: new Date().getTime(),
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.cardPlusInfo.jump_type
          }]
          _this.addLog1(logDetails) //右下悬浮块曝光
        }
      }, function () {

      })
    },
    cardJump() {
      let item = {type: this.cardPlusInfo.jump_type, data: this.cardPlusInfo.jump_data}
      this.bannerJump(item,'','click_app_suspend') //右下悬浮块点击
    },
    // 点击广告得积分
    getScoreClickAd() {
      let _this = this
      if(!_this.$store.state.wxUid){
        return
      }
      actions.scoreClickAd(_this, {}, function (res) {

      }, function () {

      })
    },
  },
  components: {
    CommentStars
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>
<style scoped>
.fs-20 {
  font-size: .2rem;
}

.fs-24 {
  font-size: .24rem;
}

.fs-40 {
  font-size: .4rem;
}

.c-eb3222 {
  color: #eb3222;
}

.c-666 {
  color: #666;
}

.bold {
  font-weight: bold;
}

.index {
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F8F8F8 10%, #F5F5F5 100%);
}

.goods-list {
  padding-bottom: .2rem;
}

.goods-box .goods-img {
  position: relative;
  width: 2rem;
  height: 2rem;
}

.goods-box .goods-img .mark {
  position: absolute;
  /*width: .5rem;*/
  padding: 0 .06rem;
  height: .3rem;
  top: 0;
  left: 0;
  line-height: .3rem;
  background-color: #FFF100;
  border-radius: .04rem;
  font-size: .22rem;
  color: #fff;
  text-align: center;
}

.goods-box .goods-img .goodimg {
  border: none;
}

.goods-box .goods-des {
  margin-left: 2.2rem;
  font-size: .22rem;
  color: #787878;
}

.goods-box .goods-des .name {
  font-size: .3rem;
  /*font-weight: normal;*/
}

.goods-box .des {
  color: #787878;
}

.goods-box .shopimg {
  /*width: 1.4rem;*/
  /*height: 1.06rem;*/
}

.goods-list ul {
  padding-bottom: .2rem;
}

.goods-list.shop ul li {
  border-top: 1px solid #f6f6f6;
}

.goods-list.shop ul li:first-child {
  border-top: none;
}

.goods-list ul li {
  border-top: none;
}

.shop-status {
  font-size: .22rem;
  color: #4a4a4a;
}

.shop-type {
  font-size: .2rem;
  margin-left: 0;
}

.shop-type-box {
  top: .4rem;
}

.notice_detail_alert.bonus{
  background: rgba(0, 0, 0, .8);
}
.notice_detail_alert.bonus .notice_detail_content{
  position: relative;
  width: 5.6rem;
}
.notice_detail_alert.bonus .notice_detail_content .close-btn{
  position: absolute;
  right: 0;
  top: -1rem;
}

.notice_detail_alert.coupon .notice_detail_content{
  position: relative;
  width: 5.6rem;
  /* padding-bottom: 2rem; */
  /* border-radius: 0.24rem; */
  /* background-color: #FD533A; */
  /* height: 7.38rem; */
}
.notice_detail_alert.coupon .body{
  /* margin: 0 .25rem; */
  /* width: 6.4rem; */
  /* height: 100%; */
  /* padding-top: 1.54rem; */
  /* padding-bottom: 2rem; */
  /* border-radius: .24rem; */
  /* background-color: #FD533A; */
  width: 5.14rem;
  margin: 0 auto;
  background-color: #FF2F13;
  padding-top: 0;
  padding-bottom: 1.4rem;
  border-radius: 0 0 .4rem .4rem;
  margin-top: -.05rem;
  /* max-height: 4rem; */
  /* overflow-y: scroll; */
}
.notice_detail_alert.coupon .title{
  /* height: 1.38rem; */
  text-align: center;
  color: #fff;
  font-size: .32rem;
  padding-bottom: .34rem;
  /* line-height: 1.38rem; */
}
.notice_detail_alert.coupon .bottom{
  position: absolute;
  bottom: 0;
  left: .27rem;
  right: .27rem;
  /* height: 2.34rem; */
  z-index: 1003;
}
.notice_detail_alert.coupon .bottom .jump-btn{
  position: absolute;
  width: 4.12rem;
  height: .9rem;
  font-weight: 500;
  color: #FF3131;
  font-size: .38rem;
  bottom: .48rem;
  left: .38rem;
  line-height: .9rem;
  text-align: center;
  background-image: linear-gradient(#FDEDDE, #FDEBA9);
  border-radius: .64rem;
  z-index: 1004;
}
.notice_detail_alert.coupon .bottom .jump-btn a{
  color: #FF3131;
}
.notice_detail_alert.coupon .body .list{
  max-height: 4.2rem;
  margin: 0 .25rem;
  overflow-y: scroll;
}
.notice_detail_alert.coupon .body .list .item{
  background: #FFFFFF;
  border-radius: .2rem;
  padding: .2rem;
  margin-bottom: .2rem;
}
.notice_detail_alert.coupon .body .list .item img{
  width: .9rem;
  margin-right: .12rem;
}
.notice_detail_alert.coupon .body .list .item .price{
  color: #FD533A;
  font-size: .28rem;
  font-weight: 600;
}
.notice_detail_alert.coupon .body .list .item .price span{
  font-size: .36rem;
}
.fixed-card{
  position: fixed;
  right: 0;
  bottom: 1.5rem;
  width: 1.12rem;
  z-index: 100;
}
.my-content{
  width: 2.50rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
}
.my-content span{
  font-weight: 400;
  color: #666666;
  line-height: .34rem;
  font-size: .24rem;
  margin-top: .24rem;
}
.fixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  padding: 0 .26rem !important;
  background-color: #fff !important;
}
.goods-list .vice_title{
  margin: 0 0 0 .2rem;
  font-size: .2rem;
  color: #FF8919;
  background: #fbf3e4;
}
.benefit{
  position: relative;
  height: 3.90rem;
  background: #FFFFFF;
  border-radius: .20rem;
  margin-bottom: .20rem;
}
.benefit .item-img{
  width: 2.00rem;
  height: 3.50rem;
}
.benefit .item-desc{
  margin-left: .16rem;
  width: 67%;
  height: 3.50rem;
}
.benefit .item-desc .item-tag {
  position: absolute;
  right: 0;
  top: 0;
  text-align: right;
  width: .9rem;
}
.benefit .item-desc .argver{
  font-weight: 400;
  font-size: .22rem;
  color: #999999;
}
.benefit .item-desc .scroller{
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  display: flex;
  align-items: center;
}
.benefit .item-desc .scroller::-webkit-scrollbar {
  display: none;
}
.index .benefit .item-desc .item-promotion,
.benefit .item-desc .item-coupon{
  display: flex;
  align-items: center;
  height: .30rem;
  line-height: .30rem;
  border-radius: .05rem;
  border: 1px solid rgba(255,74,97,0.5);
}
.benefit .item-desc .item-promotion .reduce,
.benefit .item-desc .item-coupon .desc{
  font-size: .20rem;
  color: #ff4a61;
  padding: 0 .08rem;
  border-right: 1px solid rgba(255,74,97,0.5);
}
.benefit .item-desc .item-coupon .get{
  background: #FFA4B0;
  color: #FF4A61;
  font-size: .20rem;
  padding: 0 .10rem;
}
.benefit .item-desc .item-imgs,
.benefit .item-desc .item-package{
  display: flex;
  align-items: center;
  font-size: .22rem;
  color: #999;
}
.benefit .item-desc .item-package span{
  padding: 0 .10rem;
  height: .30rem;
  line-height: .30rem;
  background: linear-gradient(125deg, #FF4A61 0%, #FD573B 100%);
  border-radius: .05rem;
  font-size: .22rem;
  color: #fff;
  margin-right: .10rem;
}
.goods-title1 {
  font-size: 0.32rem;
  color: #666666;
  font-weight: 400;
}
.goods-title1 .shop-title{
  display: flex;
  padding: .12rem 0;
}
.goods-title1  .shop-title .item{
  position: relative;
  width: 1.81rem;
  height: .55rem;
  font-size: .32rem;
  color: #666;
}
.goods-title1 .shop-title .item:first-child{
  margin-left: .22rem;
}
.goods-title1 .shop-title .item.active{
  color: #333333;
}
.goods-title1 .shop-title .item.active span {
  position: absolute;
  width: .62rem;
  height: .10rem;
  left: .33rem;
  bottom: -0.02rem;
  background-color: #FFDF00;
  border-radius: .12rem;
  margin-top: .13rem;
}
.shop-title1{
  margin: .16rem 0;
}
.shop-title1 .item1{
  width: 1.64rem;
  line-height: .50rem;
  font-size: .24rem;
  text-align: center;
  color: #999999;
  background-color: #FFFFFF;
  border-radius: .08rem;
}
.shop-title1 .item1.active{
  color: #2F2F2F;
  background: linear-gradient(to bottom, #FFEC00, #FED400);
}
</style>



// WEBPACK FOOTER //
// TagPage.vue?ac1f4f92